import React from 'react';
import { observer } from 'mobx-react';
import { FacilityInventoryCountListTemplate } from 'themes/application/facility-inventory/pages';
import { setCurrentView } from 'core/utils';
import { FacilityInventoryCountListViewStore } from 'application/facility-inventory/stores';

@setCurrentView((rootStore) => new FacilityInventoryCountListViewStore(rootStore), "facilityInventoryCountListViewStore")
@observer
class FacilityInventoryCountList extends React.Component {
    render() {
        return <FacilityInventoryCountListTemplate {...this.props} />
    }
}

export default FacilityInventoryCountList;